<template>
  <main>
    <div class="tab-header">
      <div class="container-fluid">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item" :class="{ active: currentTab === 0 }">
            <a href="#tab-0" @click.prevent="resetValid" class="nav-link active show" role="tab" data-toggle="tab"
              >保單遮蔽</a
            >
          </li>
          <li class="nav-item" :class="{ active: currentTab === 1 }">
            <a href="#tab-1" @click.prevent="resetValid" class="nav-link" role="tab" data-toggle="tab">編輯檢視</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab-content">
      <div class="container-fluid">
        <div id="tab-0" class="tab-pane active show" role="tabpanel">
          <policy-Covered-Add />
        </div>
        <div id="tab-1" class="tab-pane" role="tabpanel">
          <policy-Covered-Edit />
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { commonMixin } from '@/mixins/common';
import policyCoveredAdd from './policyCoveredAdd';
import policyCoveredEdit from './policyCoveredEdit';

export default {
  name: 'policyCovered',
  data() {
    return {};
  },
  mixins: [commonMixin],
  components: {
    policyCoveredAdd,
    policyCoveredEdit
  },
  methods: {
    resetValid() {
      this.$validator.reset();
    }
  }
};
</script>
<style lang="scss" scoped></style>
